import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCalendarChecked32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCalendarChecked32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 4.5a1 1 0 1 0-2 0V5H9a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4h-2v-.5a1 1 0 1 0-2 0V5h-6zm6 3V7h-6v.5a1 1 0 1 1-2 0V7H9a2 2 0 0 0-2 2v2h18V9a2 2 0 0 0-2-2h-2v.5a1 1 0 1 1-2 0M7 23V13h18v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2m6.599-4.97a1 1 0 0 0-1.415 1.415l2.122 2.12.707.708.707-.707 4.596-4.596a1 1 0 0 0-1.414-1.415l-3.89 3.89z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCalendarChecked32);
